import { userProfile } from "@models/services/user";
import handleResponse from "@services/apiConfig/api.response.service";
import API_SERVICES from "@services/index";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

export const userProfileKeys = {
  detail: (accessToken: string | null) => ["userProfile", accessToken] as const,
  all: ["userProfile"] as const,
};

export function useUserProfile(
  accessToken: string | null,
  options?: {
    enabled?: boolean;
    staleTime?: number;
    gcTime?: number;
  }
): UseQueryResult<userProfile, Error> {
  return useQuery({
    queryFn: async () => {
      const data = await API_SERVICES.USER.PROFILE();
      const responseData = handleResponse(data);
      if (responseData?.ok) {
        return responseData.data;
      }
      throw new Error("Failed to fetch user profile");
    },
    enabled: options?.enabled !== false && !!accessToken,
    gcTime: options?.gcTime,
    queryKey: userProfileKeys.detail(accessToken),
    staleTime: options?.staleTime,
  });
}
